import styled from 'styled-components';

const FontSize15P = styled.p`
  font-size: 15px;
  margin: 1em 0;
`;

export default FontSize15P;
